import React from "react";
import { connect } from "react-redux";

import { InfoFieldSection } from "../EditableInfoField";
import AdminOnlyWarning from "../Settings/AdminOnlyWarning";
import { updateFirmInfoField } from "../../actions/tenantActions";

// mirrors the UPDATE_FIRM_AI_CONTEXT deniedMessage in
// permissionFeaturesConstants.js — that one is what the API returns if a write
// slips through; this is the pre-emptive copy shown next to the disabled fields
const NO_ACCESS_MESSAGE =
	"You do not have access to edit Custom AI Instructions for the Firm. Please contact your firm administrator for more information.";

const FirmInfoSection = ({
	canEditFirmInfo,
	firmInfo,
	firmInfoLoading,
	updateFirmInfoField,
}) => {
	const sharedProps = {
		disabled: !canEditFirmInfo,
		disabledMessage: NO_ACCESS_MESSAGE,
		loading: firmInfoLoading,
	};
	return (
		<div>
			<InfoFieldSection
				heading="Practice Areas"
				description="List each Practice Area as your firm defines them, separated by commas. This information informs AI conversations."
				as="input"
				name="practiceAreas"
				placeholder="Enter Practice Areas, separated by commas"
				initialValue={firmInfo.practiceAreas}
				onSave={(value) => updateFirmInfoField("practiceAreas", value)}
				{...sharedProps}
			/>

			<InfoFieldSection
				style={{ marginTop: 24 }}
				heading="About the Firm"
				description="A short paragraph describing your firm. This information informs AI conversations."
				as="textarea"
				name="aboutFirm"
				initialValue={firmInfo.aboutFirm}
				onSave={(value) => updateFirmInfoField("aboutFirm", value)}
				{...sharedProps}
			/>

			<InfoFieldSection
				style={{ marginTop: 24 }}
				heading="Custom AI Instructions (Firm-Wide)"
				description={
					<>
						Enter any custom instructions or context that you want
						to be applied to <strong>every</strong> AI conversation
						for <strong>every</strong> user. Doing so can help
						ensure uniform AI experiences across your firm.
					</>
				}
				as="textarea"
				name="customAiInstructions"
				height={300}
				initialValue={firmInfo.customAiInstructions}
				onSave={(value) =>
					updateFirmInfoField("customAiInstructions", value)
				}
				{...sharedProps}
			/>

			<div style={{ marginTop: 20 }}>
				<AdminOnlyWarning
					userCanEditSettings={canEditFirmInfo}
					message={NO_ACCESS_MESSAGE}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	canEditFirmInfo: state.user.userRights
		? state.user.userRights.UPDATE_FIRM_AI_CONTEXT
		: false,
	firmInfo: state.tenant.firmInfo,
	firmInfoLoading: state.tenant.firmInfoLoading,
});

export default connect(mapStateToProps, { updateFirmInfoField })(
	FirmInfoSection
);
